import analyticsService from './analytics/analytics'
import { toastService } from '@/api/toast'
import { i18n } from '@/locale/i18n'

// VITE_FRONT_URL slice removes the trailing '/'. 
const BASE_PATH = import.meta.env.VITE_SHARE_PATH || import.meta.env.VITE_FRONT_URL?.slice(0, -1) || ''

function shareViaBrowserTwitter(url) {
  const twitterShareUrl = `https://twitter.com/home?status=${encodeURIComponent(url)}`
  window.open(twitterShareUrl, '_blank', 'noopener')
}

function shareViaBrowserFacebook(url) {
  const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`
  window.open(shareUrl, '_blank', 'noopener')
}

function shareViaBrowserWhatsapp(url) {
  let whatsappUrl = 'https://wa.me/?text=' + encodeURIComponent(url)
  window.open(whatsappUrl, '_blank', 'noopener')
}

function shareViaBrowserLinkedin(url) {
  const linkedinUrl = 'https://www.linkedin.com/shareArticle?url=' + encodeURIComponent(url)
  window.open(linkedinUrl, '_blank', 'noopener')
}

function shareViaBrowserReddit(url) {
  const redditUrl = 'https://reddit.com/submit?url=' + encodeURIComponent(url)
  window.open(redditUrl, '_blank', 'noopener')
}

function shareViaBrowserCopyLink(url) {
  const available = instance && instance.shareInput

  if (!available) {
    console.warn('Share <input> is not available.')
    return
  }

  instance.shareInput.value = url
  instance.shareInput.select()
  document.execCommand('copy')
  toastService('success', { title: i18n('snackbar.copylink') })
}

function shareViaBrowser(url, type) {
  switch (type) {
    case 'facebook':
      shareViaBrowserFacebook(url)
      break

    case 'twitter':
      shareViaBrowserTwitter(url)
      break

    case 'whatsapp':
      shareViaBrowserWhatsapp(url)
      break

    case 'reddit':
      shareViaBrowserReddit(url)
      break

    case 'linkedin':
      shareViaBrowserLinkedin(url)
      break

    case 'copylink':
      shareViaBrowserCopyLink(url)
      break

    default:
      console.warn('Invalid share type.', type, url)
      break
  }
}

class ShareService {
  constructor() {
    if (typeof window !== 'undefined') {
      this.shareInput = document.createElement('input')
      this.shareInput.readOnly = true
      this.shareInput.tabIndex = -1
      this.shareInput.setAttribute('aria-hidden', 'true')
      this.shareInput.style.cssText = `
        position: absolute;
        top: -10000px;
        opacity: 0;
        pointer-events: none;
      `
      window.document.body.appendChild(this.shareInput)
    }
  }

  // TODO: add onError, onSuccess callbacks or make Promise.
  share({ type, url }) {
    const shareUrl = url.startsWith('http') ? url : this.shareableUrl(url)
    analyticsService.track('share', { url: shareUrl, provider: type })

    return shareViaBrowser(shareUrl, type)
  }

  shareableUrl(url) {
    if (!url) return BASE_PATH
    // Avoid breaking absolute URLs during SSR (e.g. requestUrl already includes protocol/host).
    if (/^https?:\/\//i.test(url)) return url
    return BASE_PATH + url
  }
}

const instance = new ShareService()
export default instance
